import { useWorkService } from "../../../services/work.service";
import ActiveWorkers from "./active-workers";

export default function TranscriptionQueue() {
  const { getActiveWorkers, unassignWorker, unassignAllWorkers } = useWorkService();

  return (
    <ActiveWorkers
      title="Transcription Queue"
      emptyMessage="No active workers"
      getWorkersFn={getActiveWorkers}
      unassignWorkerFn={unassignWorker}
      unassignAllWorkersFn={unassignAllWorkers}
    />
  );
}
